import { render, staticRenderFns } from "./CreatePostConfigureStep.vue?vue&type=template&id=b3e95ae4&scoped=true"
import script from "./CreatePostConfigureStep.vue?vue&type=script&lang=js"
export * from "./CreatePostConfigureStep.vue?vue&type=script&lang=js"
import style0 from "./CreatePostConfigureStep.vue?vue&type=style&index=0&id=b3e95ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e95ae4",
  null
  
)

export default component.exports